module.exports = __webpack_public_path__ + "static/media/White_goods.c7064762.svg";